import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import { theme } from '../../../theme/theme';

import { useGetKPIDataQuery } from "../apiDashboard";

import { ReactComponent as InstalledDevicesIcon } from '../../../assets/DevicesIcon.svg';
import { ReactComponent as OnlineDevicesIcon } from '../../../assets/NetworkConnectivityIcon.svg';
import { ReactComponent as UniquePlanesIcon } from '../../../assets/AirplaneHealthIcon.svg';
import { ReactComponent as LatestCatalogIcon } from '../../../assets/ContentHealthIcon.svg';
import { ReactComponent as LatestSoftwareIcon } from '../../../assets/SoftwareHealthIcon.svg';
import { ReactComponent as EdgeUsageIcon } from '../../../assets/EdgeUsageIcon.svg';
import { ReactComponent as OTAUpdatesIcon } from '../../../assets/OTAUpdatesIcon.svg';
import { ReactComponent as SmallInfoIcon } from '../../../assets/SmallInfoIcon.svg';
import { ReactComponent as SmallClockIcon } from '../../../assets/SmallClockIcon.svg';
import { ReactComponent as SmallCalendarIcon } from '../../../assets/SmallCalendarIcon.svg';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import {
  AppBar,
  Container,
  List,
  ListItem,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';

const NoMaxWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
  },
});

const KpiBar = (props) => {

  const {
    data: kpiData,
  } = useGetKPIDataQuery({ type: props.type }, { pollingInterval: 10000, refetchOnMountOrArgChange: true, refetchOnFocus: true, refetchOnReconnect: true  });

  const installedDevices = (
  <>
    <Grid container direction={'row'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{maxHeight: '90px', overflowY: 'hidden', flexShrink: 0}}>
      <Grid item xs={3} display='flex' alignItems={'center'} justifyContent={'center'} sx={{ 
        minWidth: '45px', 
        width: '45px', 
        maxWidth: '45px!important', 
        minHeight: '45px',
        height: '45px', 
        maxHeight: '45px!important', 
        borderRadius: '50%', 
        border: '2px white solid' 
      }}>
        <InstalledDevicesIcon width={'25px'} height={'25px'} color={'white'} />
      </Grid>
      <Grid container item xs="auto" direction={'column'} sx={{ml: 1}}>
        <Grid item>
          <Typography fontSize={25} fontWeight={700}>
            {kpiData?.installedDevices ?? 'n/a'}
          </Typography>
        </Grid>
        <Grid item>
          <Typography fontSize={20} sx={{color: 'white', whiteSpace: 'nowrap'}}>
            Installed Devices
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  </>);
  const onlineDevices = (
  <>
    <Grid container direction={'row'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{minWidth: '138px', maxHeight: '90px', overflowY: 'hidden', flexShrink: 0}}>
      <Grid item xs={3} display='flex' alignItems={'center'} justifyContent={'center'} sx={{ 
        minWidth: '45px', 
        width: '45px', 
        maxWidth: '45px!important', 
        minHeight: '45px',
        height: '45px', 
        maxHeight: '45px!important', 
        borderRadius: '50%', 
        border: '2px white solid' 
      }}>
        <OnlineDevicesIcon width={'25px'} height={'25px'} color={'white'} />
      </Grid>
      <Grid container item xs="auto" direction={'column'} sx={{ml: 1}}>
        <Grid container item direction={'row'}>
          <Typography fontSize={25} fontWeight={700}>
            {kpiData?.onlineDevicesLower ?? 'n/a'} <SmallClockIcon />
          </Typography>
          <Typography fontSize={25} fontWeight={200} sx={{mx: 1, color: '#AEB1B4'}}>
            |
          </Typography>
          <Typography fontSize={25} fontWeight={700}>
            {kpiData?.onlineDevicesHigher ?? 'n/a'} <SmallCalendarIcon />
          </Typography>
        </Grid>
        <Grid item>
          <Typography fontSize={20} sx={{color: 'white', whiteSpace: 'nowrap'}}>Online Devices <NoMaxWidthTooltip title={
            <Stack>
              <Grid item>
                <SmallClockIcon /> <Typography display="inline" fontSize={16}>Active VPN in last 24 hours</Typography>
              </Grid>
              <Grid item>
                <SmallCalendarIcon /> <Typography display="inline" fontSize={16}>Active VPN in last 30 days </Typography>
              </Grid>
            </Stack>}>              
              <SmallInfoIcon />
            </NoMaxWidthTooltip>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  </>);
  const uniquePlanes = (
    <>
      <Grid container direction={'row'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{minWidth: '138px', maxHeight: '90px', overflowY: 'hidden', flexShrink: 0}}>
        <Grid item xs={3} display='flex' alignItems={'center'} justifyContent={'center'} sx={{ 
          minWidth: '45px', 
          width: '45px', 
          maxWidth: '45px!important', 
          minHeight: '45px',
          height: '45px', 
          maxHeight: '45px!important', 
          borderRadius: '50%', 
          border: '2px white solid' 
        }}>
          <UniquePlanesIcon width={'25px'} height={'25px'} color={'white'} />
        </Grid>
        <Grid container item xs="auto" direction={'column'} sx={{ml: 1}}>
          <Grid container item direction={'row'}>
            <Typography fontSize={25} fontWeight={700}>
              {kpiData?.uniquePlanesLower ?? 'n/a'} <SmallClockIcon />
            </Typography>
            <Typography fontSize={25} fontWeight={200} sx={{mx: 1, color: '#AEB1B4'}}>
              |
            </Typography>
            <Typography fontSize={25} fontWeight={700}>
              {kpiData?.uniquePlanesHigher ?? 'n/a'} <SmallCalendarIcon />
            </Typography>
          </Grid>
          <Grid item>
            <Typography fontSize={20} sx={{color: 'white', whiteSpace: 'nowrap'}}>
              Unique Planes <NoMaxWidthTooltip title={
              <Stack>
                <Grid item>
                  <SmallClockIcon /> <Typography display="inline" fontSize={16}>Planes connected across network in last 24 hours</Typography>
                </Grid>
                <Grid item>
                  <SmallCalendarIcon /> <Typography display="inline" fontSize={16}>Planes connected across network in last 30 days</Typography> 
                </Grid>
              </Stack>}>
                <SmallInfoIcon />
              </NoMaxWidthTooltip>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>);
  const latestCatalog = (
    <>
      <Grid container direction={'row'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{minWidth: '90px', maxHeight: '90px', overflowY: 'hidden', flexShrink: 0}}>
        <Grid item xs={3} display='flex' alignItems={'center'} justifyContent={'center'} sx={{ 
          minWidth: '45px', 
          width: '45px', 
          maxWidth: '45px!important', 
          minHeight: '45px',
          height: '45px', 
          maxHeight: '45px!important', 
          borderRadius: '50%', 
          border: '2px white solid' 
        }}>
          <LatestCatalogIcon width={'25px'} height={'25px'} color={'white'} />
        </Grid>
        <Grid container item xs="auto" direction={'column'} sx={{ml: 1}}>
          <Grid item>
            <Typography fontSize={25} fontWeight={700} sx={{whiteSpace: "nowrap"}}>
              {kpiData?.latestCatalogPercent >= 0 ? Math.round(kpiData.latestCatalogPercent * 100) : "Unknown"} %
            </Typography>
          </Grid>
          <Grid item>
            <Typography fontSize={20} sx={{color: 'white', whiteSpace: 'nowrap'}}>
              Latest Catalog
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>);
  const latestSoftware = (
    <>
      <Grid container direction={'row'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{minWidth: '90px', maxHeight: '90px', overflowY: 'hidden', flexShrink: 0}}>
        <Grid item xs={3} display='flex' alignItems={'center'} justifyContent={'center'} sx={{ 
          minWidth: '45px', 
          width: '45px', 
          maxWidth: '45px!important', 
          minHeight: '45px',
          height: '45px', 
          maxHeight: '45px!important', 
          borderRadius: '50%', 
          border: '2px white solid' 
        }}>
          <LatestSoftwareIcon width={'25px'} height={'25px'} color={'white'} />
        </Grid>
        <Grid container item xs="auto" direction={'column'} sx={{ml: 1}}>
          <Grid item>
            <Typography fontSize={25} fontWeight={700} sx={{whiteSpace: "nowrap"}}>
              {kpiData?.latestSoftwarePercent >= 0 ? Math.round(kpiData.latestSoftwarePercent * 100) : "Unknown"} %
            </Typography>
          </Grid>
          <Grid item>
            <Typography fontSize={20} sx={{color: 'white', whiteSpace: 'nowrap'}}>
              Latest Software
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>);
  const edgeUsage = (
    <>
      <Grid container direction={'row'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{minWidth: '90px', maxHeight: '90px', overflowY: 'hidden', flexShrink: 0}}>
        <Grid item xs={3} display='flex' alignItems={'center'} justifyContent={'center'} sx={{ 
          minWidth: '45px', 
          width: '45px', 
          maxWidth: '45px!important', 
          minHeight: '45px',
          height: '45px', 
          maxHeight: '45px!important', 
          borderRadius: '50%', 
          border: '2px white solid' 
        }}>
          <EdgeUsageIcon width={'25px'} height={'25px'} color={'white'} />
        </Grid>
        <Grid container item xs="auto" direction={'column'} sx={{ml: 1}}>
          <Grid item>
            <Typography fontSize={25} fontWeight={700} sx={{whiteSpace: "nowrap"}}>
              {kpiData?.edgeUsagePercent >= 0 ? Math.round(kpiData.edgeUsagePercent * 100) : "Unknown"} %
            </Typography>
          </Grid>
          <Grid item>
            <Typography fontSize={20} sx={{color: 'white', whiteSpace: 'nowrap'}}>
              Edge Usage %
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>);
  const otaUpdates = (
  <>
    <Grid container direction={'row'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{minWidth: '138px', maxHeight: '90px', overflowY: 'hidden', flexShrink: 0}}>
      <Grid item xs={3} display='flex' alignItems={'center'} justifyContent={'center'} sx={{ 
        minWidth: '45px', 
        width: '45px', 
        maxWidth: '45px!important', 
        minHeight: '45px',
        height: '45px', 
        maxHeight: '45px!important', 
        borderRadius: '50%', 
        border: '2px white solid' 
      }}>
        <OTAUpdatesIcon width={'25px'} height={'25px'} color={'white'} />
      </Grid>
      <Grid container item xs="auto" direction={'column'} sx={{ml: 1}}>
        <Grid container item direction={'row'}>
          <Typography fontSize={25} fontWeight={700}>
            {kpiData?.dailyOTA ?? 'n/a'} <SmallClockIcon />
          </Typography>
          <Typography fontSize={25} fontWeight={200} sx={{mx: 1, color: '#AEB1B4'}}>
            |
          </Typography>
          <Typography fontSize={25} fontWeight={700}>
            {kpiData?.monthlyOTA ?? 'n/a'} <SmallCalendarIcon />
          </Typography>
        </Grid>
        <Grid item>
          <Typography fontSize={20} sx={{color: 'white', whiteSpace: 'nowrap'}}>OTA Updates <NoMaxWidthTooltip title={
            <Stack>
              <Grid item>
                <SmallClockIcon /> <Typography display="inline" fontSize={16}>OTA updates in last 24 hours</Typography>
              </Grid>
              <Grid item>
                <SmallCalendarIcon /> <Typography display="inline" fontSize={16}>OTA updates in last 30 days </Typography>
              </Grid>
            </Stack>}>              
              <SmallInfoIcon />
            </NoMaxWidthTooltip>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  </>);

  const kpiEls = [installedDevices, onlineDevices, uniquePlanes, latestCatalog, latestSoftware, edgeUsage, otaUpdates]

  return (
    <AppBar position="fixed" sx={{backgroundColor: theme.palette.secondary.main, top: 80, height: 90, p: 0}}>
      <Container maxWidth="false">
        <Toolbar disableGutters>
          <List sx={{display: 'flex', flexGrow: 1, alignItems: 'center', justifyContent: 'space-between'}}>
            {kpiEls.map((kpi, index) => (
              <ListItem 
                disablePadding
                sx={{width:"auto", flexWrap:"nowrap"}}
                key={index}>
                {kpi}
              </ListItem>
            ))}
          </List>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default KpiBar;
